module.exports = __webpack_public_path__ + "media/theme/itunes-abd3c20e.svg";